import { bl_fi_tradein_stock_hdr_RowClass} from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class TradeInStockContainerModel extends BaseContainerModel {
  bl_fi_tradein_stock_hdr: bl_fi_tradein_stock_hdr_RowClass = new bl_fi_tradein_stock_hdr_RowClass();
}